import { render, staticRenderFns } from "./owner-connect.vue?vue&type=template&id=d6f99cb2"
import script from "./owner-connect.vue?vue&type=script&lang=js"
export * from "./owner-connect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports